const buildFindAllUrl = (base, filters) => {
  let hasAFilter = false
  const statuses = []

  if (filters.status.toDo) {
    statuses.push('status[]=toDo')
    hasAFilter = true
  }
  if (filters.status.requested) {
    statuses.push('status[]=requested')
    hasAFilter = true
  }
  if (filters.status.inProgress) {
    statuses.push('status[]=inProgress')
    hasAFilter = true
  }
  if (filters.status.done) {
    statuses.push('status[]=done')
    hasAFilter = true
  }

  const dates = []
  if (filters.datetimeFrom) {
    dates.push(`date[startDate]=${filters.datetimeFrom}`)
    hasAFilter = true
  }
  if (filters.datetimeTo) {
    dates.push(`date[endDate]=${filters.datetimeTo}`)
    hasAFilter = true
  }

  let parentEvent = null
  if (filters.parentEvent) {
    parentEvent = `&parentEvent=${filters.parentEvent}`
    hasAFilter = true
  }

  let url = base

  if (hasAFilter) {
    url += '?'
  }

  statuses.forEach((status, index) => {
    url += status
    if (index < statuses.length) url += '&'
  })

  dates.forEach((date, index) => {
    url += date
    if (index < dates.length - 1) url += '&'
  })

  if (parentEvent) {
    url += parentEvent
  }

  return url
}

export {
  buildFindAllUrl
}
